var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPythonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0.21 -0.077 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.023-.077c-25.971 0-26.25 10.081-26.25 12.156v12.594h26.75v3.781H18.148C10.199 28.454.21 33.287.21 54.704c0 19.673 7.792 27.281 15.656 27.281h9.344V68.86c0-5.491 2.721-15.656 15.406-15.656h26.531c3.902 0 14.906-1.696 14.906-14.406V14.579c.001-3.153-.538-14.656-27.03-14.656m-14.75 8.469a4.807 4.807 0 0 1 4.813 4.813c0 2.661-2.151 4.813-4.813 4.813s-4.813-2.151-4.813-4.813a4.807 4.807 0 0 1 4.813-4.813"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.397 109.923c25.959 0 26.282-10.271 26.282-12.156V85.173H54.897v-3.781h37.375c8.009 0 17.938-4.954 17.938-26.25 0-23.322-10.538-27.281-15.656-27.281H85.21v13.125c0 5.491-2.631 15.656-15.406 15.656H43.272c-3.892 0-14.906 1.896-14.906 14.406v24.219c0 5.23 3.196 14.656 27.031 14.656m14.751-8.469c-2.662 0-4.813-2.151-4.813-4.813s2.15-4.813 4.813-4.813c2.661 0 4.813 2.151 4.813 4.813s-2.152 4.813-4.813 4.813"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonLogo);
export default __webpack_public_path__ + "static/media/Python_Logo.3e0df478e5d7819aadd745af1e0104b4.svg";
export { ForwardRef as ReactComponent };